import store from '@/store';

const routes = [
  {
    path: '/settings/resources',
    component: () => import(/* webpackChunkName: "ResourcesSettings" */ './views/ResourcesSettingsPage.vue'),
    name: 'resources-settings',
    props: (route) => ({ ...route.query }),
    meta: { i18n: 'resources-settings-pov' },
    beforeEnter: (to, from, next) => {
      const featureFlagsLoaded = store.getters['BusinessStore/featureFlagsLoaded'];

      if (featureFlagsLoaded) {
        const hasResourcesSettingsFeature = store.getters['BusinessStore/hasFeature']('resources_settings');
        if (hasResourcesSettingsFeature) {
          next();
        } else {
          next('/');
        }
      } else {
        // If feature flags aren't loaded yet, proceed and let component handle access
        // The component will redirect if needed once flags are loaded
        next();
      }
    },
  },
];

export default routes;
